(function(){
angular.module('ui2.0Service').factory('showPageTileService', function () {
		var tiles = {"obligation":0,"serviceLevels":0,"interpretations":0,"changeRequests":0,"workOrderRequests":0,"documentHistory":0};
		return {
			allTilesCount	: allTilesCount,
			getTileCount	: getTileCount,
			setSelectedTile	: setSelectedTile,
			getSelectedTile	: getSelectedTile,
			tiles: tiles
	    }


		var selectedTile = {};

		function allTilesCount (tilesCount) {
			tiles = tilesCount;
		}

		function getTileCount (tab) {
			let count = tiles[tab.styleClass] > 999 ? '999+' : tiles[tab.styleClass];
			return count;
		}

		function setSelectedTile(tile) {
			selectedTile = tile;
		}

		function getSelectedTile(){
			return selectedTile;
		}
	});
})();